export default __webpack_public_path__ + "static/media/11.63459d87.jpg";